import { CdkTrapFocus } from '@angular/cdk/a11y';
import { Component, output, input } from '@angular/core';

import { ApIconComponent } from '@ap/icon';

@Component({
    selector: 'ap-multi-action-button',
    templateUrl: 'multi-action.component.html',
    styleUrls: ['./multi-action.component.scss'],
    imports: [ApIconComponent, CdkTrapFocus]
})
export class ApMultiActionComponent {
    /**
     * Required - List of actions to show
     */
    public readonly actions = input.required<string[]>();

    /**
     * Is the button disabled
     */
    public readonly isDisabled = input(false);

    /**
     * Emits when action is chosen by user
     */
    public actionChosen = output<string>();

    protected isDropdownOpen = false;

    protected emitAction(action: string, event?: Event): void {
        if (!this.isDisabled()) {
            event && event.preventDefault();
            this.closeDropdown();
            this.actionChosen.emit(action);
        }
    }

    protected toggleDropdown(): void {
        if (!this.isDisabled()) {
            this.isDropdownOpen ? this.closeDropdown() : this.openDropdown();
        }
    }

    protected closeDropdown(): void {
        this.isDropdownOpen = false;
    }

    private openDropdown(): void {
        this.isDropdownOpen = true;
    }
}
